import { WidgetType } from './widget-type';

/**
 * Widget dimension constants
 * All dimensions are in gridster cells (columns x rows)
 */
export class WidgetDimensions {
  /**
   * Default widget dimensions for types not specified in WIDGET_SIZE_MAP
   */
  static readonly DEFAULT_WIDTH = 15;
  static readonly DEFAULT_HEIGHT = 15;

  /**
   * Smallest possible widget dimensions (SINGLE_METRIC)
   * Used for early space validation before widget creation
   */
  static readonly SMALLEST_WIDGET_WIDTH = 12;
  static readonly SMALLEST_WIDGET_HEIGHT = 7;

  /**
   * Map of widget types to their initial dimensions
   */
  static readonly WIDGET_SIZE_MAP: Map<WidgetType, { w: number; h: number }> = new Map([
    // Socio-demographic widgets
    [WidgetType.SOCIODEMO_GENDER, { w: 18, h: 20 }],
    [WidgetType.SOCIODEMO_PARENTING, { w: 12, h: 20 }],
    [WidgetType.SOCIODEMO_CHILDREN, { w: 22, h: 22 }],
    [WidgetType.SOCIODEMO_EDUCATION, { w: 22, h: 22 }],
    [WidgetType.SOCIODEMO_RELATION, { w: 18, h: 24 }],

    // Persona widgets
    [WidgetType.PERSONA_PERSONALITY, { w: 22, h: 16 }],
    [WidgetType.PERSONA_SUMMARY, { w: 20, h: 22 }],
    [WidgetType.PERSONA_REACH, { w: 16, h: 32 }],
    [WidgetType.PERSONA_CONTENT, { w: 25, h: 25 }],
    [WidgetType.PERSONA_STORY, { w: 25, h: 10 }],
    [WidgetType.PERSONA_BRANDS, { w: 25, h: 25 }],
    [WidgetType.PERSONA_PERSONALITIES, { w: 25, h: 25 }],
    [WidgetType.PERSONA_EVENTS, { w: 25, h: 25 }],
    [WidgetType.PERSONA_ORGANIZATIONS, { w: 25, h: 25 }],
    [WidgetType.PERSONA_MEDIA, { w: 25, h: 25 }],

    // Icon widgets
    [WidgetType.ICONS, { w: 25, h: 25 }],

    // Map widgets
    [WidgetType.MAP_MAP, { w: 20, h: 26 }],
    [WidgetType.MAP_TABLE, { w: 22, h: 32 }],

    // Title widgets
    [WidgetType.TITLE, { w: 50, h: 6 }],

    // Single metric (smallest widget)
    [WidgetType.SINGLE_METRIC, { w: 12, h: 7 }],
  ]);

  /**
   * Get dimensions for a specific widget type
   * Returns default dimensions if type is not in the map
   */
  static getDimensions(type: WidgetType): { w: number; h: number } {
    return this.WIDGET_SIZE_MAP.get(type) || {
      w: this.DEFAULT_WIDTH,
      h: this.DEFAULT_HEIGHT,
    };
  }
}
